'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationReviewService = function OnlineLogitCalibrationReviewService($q, calibrationAnalysisConstants, logitSharesDataService, logitSharesDataTransformationService, logitSharesNormalizationService, momentService, configurationService) {
  function retrieveLogitSharesData(logitSharesRequest) {
    return $q.all([logitSharesDataService.getMaxRTP(logitSharesRequest.origin, logitSharesRequest.destination), logitSharesDataService.getLogitHepProfiles(logitSharesRequest), logitSharesDataService.getServices(logitSharesRequest), logitSharesDataService.getPublishedLogitProfiles(logitSharesRequest)]);
  }
  function prepareLogitSharesDataRequest(selectedCalibration, selectedFilter, selectedView) {
    var market = selectedCalibration.market.split('-');
    var scenarioName = getScenarioName(selectedCalibration);
    return {
      origin: market[0],
      destination: market[1],
      dayOfWeek: selectedFilter.selectedDow.value,
      classGroup: selectedFilter.selectedClassGroup,
      dateRangeStart: selectedCalibration.startDate.format(momentService.FORMAT.DATE_ISO),
      dateRangeEnd: selectedCalibration.endDate.format(momentService.FORMAT.DATE_ISO),
      fareBucketSize: selectedCalibration.fareBucket,
      timeBucketSize: selectedCalibration.travelTimeBucket,
      viewType: selectedView,
      significantPos: 'Default',
      calibrationName: selectedCalibration.calibrationName,
      scenarioName: scenarioName,
      reviewStartDate: selectedCalibration.reviewStartDate,
      reviewEndDate: selectedCalibration.reviewEndDate
    };
  }
  function getScenarioName(selectedCalibration) {
    if (selectedCalibration.active === calibrationAnalysisConstants.CALIBRATION_STATUSES.INACTIVE) {
      return;
    }
    return _.isUndefined(selectedCalibration.assigned) ? _.join(['AVRO', selectedCalibration.calibrationName, selectedCalibration.market], '-') : calibrationAnalysisConstants.SCENARIO_NAME_PUBLISHED;
  }
  function extractLogitDataForCharts(promises, logitSharesRequest) {
    var maxRtp = promises[0];
    var logitHepProfiles = promises[1];
    var services = promises[2];
    var publishedLogitProfile = promises[3];
    var transformedServices = [];
    var transformedLogitParams = [];
    var contextData;
    var filteredLogitProfile = _.chain(logitHepProfiles).filter(function (profile) {
      return profile.attributes.classSetId === logitSharesRequest.classGroup && profile.attributes.dayOfWeek === logitSharesRequest.dayOfWeek;
    }).map(function (profile) {
      var logitParams = profile.properties.logitParams;
      _.forEach(logitParams, function (param) {
        logitSharesDataTransformationService.setDefaults(param);
      });
      return profile;
    }).first().value();
    if (!_.isUndefined(filteredLogitProfile)) {
      transformedServices = logitSharesDataTransformationService.transformServiceData(services, logitSharesRequest);
      transformedLogitParams = logitSharesDataTransformationService.extractLogitParams(maxRtp, filteredLogitProfile, publishedLogitProfile);
      var logitRequest = _.pick(logitSharesRequest, ['viewType', 'fareBucketSize', 'timeBucketSize', 'reviewStartDate', 'reviewEndDate']);
      var hepAttributes = filteredLogitProfile.attributes;
      hepAttributes.market = hepAttributes.origin + '-' + hepAttributes.destination;
      hepAttributes.key = filteredLogitProfile.hepKey;
      contextData = _.extend(logitRequest, hepAttributes);
    }
    return {
      logitParams: transformedLogitParams,
      services: transformedServices,
      maxRtp: maxRtp,
      contextData: contextData
    };
  }
  function invalidateDataCache() {
    logitSharesDataService.invalidateCache();
  }
  function publishProfiles(calibrationData) {
    var market = calibrationData.market.split('-');
    var updateRequest = {
      publish: true,
      origin: market[0],
      destination: market[1],
      calibrationName: calibrationData.calibrationName
    };
    return logitSharesDataService.publishProfiles(calibrationData, getScenarioName(calibrationData)).then(function (response) {
      return logitSharesDataService.updateLogitCalibration(updateRequest);
    });
  }
  function saveLogitProfiles(profiles, updateRequest) {
    var transformedProfiles = _.chain(profiles).map(function (profile) {
      var logitParams = profile.properties.logitParams;
      logitSharesNormalizationService.transformTodSharesToLogits(logitParams);
      return logitSharesDataTransformationService.transformProfileForSave(profile);
    }).value();
    return logitSharesDataService.saveLogitProfiles(transformedProfiles).then(function (response) {
      return logitSharesDataService.updateLogitCalibration(updateRequest);
    });
  }
  function getClassGroups(market) {
    return _.chain(configurationService.getClassGroupMapping(market)).keys().sort().value();
  }
  return {
    getClassGroups: getClassGroups,
    prepareLogitSharesDataRequest: prepareLogitSharesDataRequest,
    retrieveLogitSharesData: retrieveLogitSharesData,
    extractLogitDataForCharts: extractLogitDataForCharts,
    invalidateDataCache: invalidateDataCache,
    saveLogitProfiles: saveLogitProfiles,
    publishProfiles: publishProfiles
  };
};
OnlineLogitCalibrationReviewService.$inject = ['$q', 'CalibrationAnalysisConstants', 'LogitSharesDataService', 'LogitSharesDataTransformationService', 'LogitSharesNormalizationService', 'MomentService', 'ConfigurationService'];
module.exports = OnlineLogitCalibrationReviewService;